import React, { useEffect, useState } from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { getThreadsByCategoryIds } from '../../services/boardService';
import { getCategoryById } from '../../data/boardCategories';
import BoardThreadCard from '../../components/board/BoardThreadCard';

function BoardCategory() {
  const { categoryId } = useParams();
  const category = getCategoryById(categoryId);

  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!category) return;

    const categoryIds = categoryId === 'gear' ? ['gear', 'winter-gear'] : [categoryId];
    getThreadsByCategoryIds(categoryIds, 40)
      .then(setThreads)
      .catch((err) => console.error('[BoardCategory]', err))
      .finally(() => setLoading(false));
  }, [categoryId, category]);

  if (!category) return <Navigate to="/board" replace />;

  const isGear = categoryId === 'gear';

  return (
    <div style={{ maxWidth: '896px', margin: '0 auto', padding: '24px 16px' }}>
      <nav style={{ fontSize: '13px', color: 'var(--ch-muted)', marginBottom: '16px' }}>
        <Link to="/board" style={{ color: 'var(--ch-link)' }}>トップ</Link>
        <span style={{ margin: '0 8px' }}>/</span>
        <span>{isGear ? '装備' : category.name}</span>
      </nav>

      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px', marginBottom: '24px', flexWrap: 'wrap' }}>
        <div>
          <h1 style={{ fontSize: '20px', fontWeight: 700, color: 'var(--ui-accent-text)', margin: 0 }}>
            {isGear ? '装備' : category.name}
          </h1>
          {isGear && (
            <p className="revisit-meta" style={{ fontSize: '13px', marginTop: '4px' }}>
              靴、レイヤリング、ザック、テント、冬装備までまとめて見られます。
            </p>
          )}
        </div>
        <Link
          to={`/board/new-thread?categoryId=${categoryId}`}
          style={{
            backgroundColor: 'var(--ch-thread-btn)',
            color: '#ffffff',
            padding: '6px 16px',
            borderRadius: '4px',
            fontSize: '13px',
            textDecoration: 'none',
          }}
        >
          相談する
        </Link>
      </div>

      {/* サブカテゴリ一覧（gearは全スレ表示、それ以外はサブカテゴリリスト） */}
      {!isGear && (
        <div style={{ marginBottom: '24px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {category.subCategories.map((sub) => (
            <Link
              key={sub.id}
              to={`/board/${categoryId}/${sub.id}`}
              style={{
                display: 'block',
                borderRadius: '8px',
                border: '1px solid var(--ch-border)',
                backgroundColor: 'var(--ch-bg-post)',
                padding: '14px 16px',
                color: 'var(--ch-text)',
                fontSize: '14px',
                fontWeight: 500,
                textDecoration: 'none',
                transition: 'border-color 0.15s',
              }}
              onMouseOver={(e) => { e.currentTarget.style.borderColor = '#4ade80'; }}
              onMouseOut={(e) => { e.currentTarget.style.borderColor = 'var(--ch-border)'; }}
            >
              {sub.name}
            </Link>
          ))}
        </div>
      )}

      {/* スレッド一覧（gearのみ表示） */}
      {isGear && (
        <>
          {loading ? (
            <div className="revisit-panel" style={{ borderRadius: '12px', padding: '20px' }}>
              <p className="revisit-meta" style={{ fontSize: '14px' }}>読み込み中...</p>
            </div>
          ) : (
            <div style={{ border: '1px solid var(--ch-border)', backgroundColor: 'var(--ch-bg-post)' }}>
              {threads.length === 0 ? (
                <p style={{ textAlign: 'center', padding: '32px 0', fontSize: '13px', color: 'var(--ch-muted)' }}>
                  まだスレッドはありません
                </p>
              ) : (
                threads.map((t, i) => (
                  <BoardThreadCard
                    key={t.id}
                    thread={t}
                    categoryId={t.categoryId}
                    subCategoryId={t.subCategoryId}
                    index={i}
                  />
                ))
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default BoardCategory;
